import {Injectable} from '@angular/core';

@Injectable()
export class OrdersDeclinedDigitalSignService {
	private ordersDeclinedDS = new Set<number>();

	addOrderDeclinedDs(orderID: number) {
		this.ordersDeclinedDS.add(orderID);
	}

	removeOrderDeclinedDs(orderID: number) {
		this.ordersDeclinedDS.delete(orderID);
	}

	areOrderDeclinedDs(orderID: number): boolean {
		return this.ordersDeclinedDS.has(orderID);
	}
}
